'use client'

import { useEffect } from 'react'
import { defineRichElements } from './elements/registry'

export function RichContentEnhancer() {
  useEffect(() => defineRichElements(), [])
  return null
}
